import React, { useEffect, useState } from 'react';
import { Typography, Box, TextField, InputAdornment, Chip } from '@mui/material';
import { Search } from '@mui/icons-material';
import { debounce } from 'lodash';
import toast from 'react-hot-toast';

import Breadcrumb from 'src/layouts/full/shared/breadcrumb/Breadcrumb';
import PageContainer from 'src/components/container/PageContainer';
import DataTable from '../../../components/DataTable/DataTable';
import { fget } from '../../../axios/axiosCalls';

const BCrumb = [
  {
    to: '/',
    title: 'Home',
  },
  {
    title: 'Enquiries',
  },
];

const Enquiries = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');

  const columns = [
    { field: 'name', headerName: 'Name', flex: 1 },
    { field: 'phone', headerName: 'Phone', flex: 0.8 },
    { 
      field: 'property', 
      headerName: 'Property', 
      flex: 1,
      renderCell: (params) => {
        
        if (!params.property) return '-';
        return (
          <Typography variant="body2">
            {params.property.propertyName || 'N/A'}
          </Typography>
        );
      }
    },
    { field: 'campus', headerName: 'Campus', flex: 0.8 },
    { field: 'intake', headerName: 'Intake', flex: 0.6 },
    { 
      field: 'status', 
      headerName: 'Status', 
      flex: 0.6,
      renderCell: (params) => (
        <Chip 
          label={params.status}
          color={params.status !== 'pending' ? 'success' : 'warning'}
          size="small"
        />
      )
    },
    {
      field: 'createdAt',
      headerName: 'Created Date',
      flex: 0.8,
      renderCell: (params) => new Date(params.createdAt).toLocaleDateString()
    },
    // {
    //   field: 'bitContacted',
    //   headerName: 'Contacted',
    //   flex: 0.6,
    //   renderCell: (params) => params.bitContacted ? 'Yes' : 'No'
    // }
  ];

  const debouncedSearch = debounce((query) => {
    setSearchQuery(query);
    setPage(0);
    fetchData(0, rowsPerPage, query);
  }, 500);

  const fetchData = async (page, limit, search = '') => {
    setLoading(true);
    try {
      const response = await fget({
        url: '/api/v2/enquiries',
        params: {
          page: page + 1,
          limit,
          term: search
        }
      });
      
      if (response.data.status === 'Success') {
        setRows(response.data.enquiries);
        setTotalRows(response.data.pagination.totalCount);
      }
    } catch (error) {
      toast.error('Failed to fetch enquiries');
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
    setPage(0);
  };

  useEffect(() => {
    fetchData(page, rowsPerPage, searchQuery);
  }, [page, rowsPerPage]);

  return (
    <PageContainer title="Enquiries" description="Enquiries List">
        <Breadcrumb title="Enquiries" items={BCrumb} />
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', mb: 3 }}>
            
            <TextField
                placeholder="Search enquiries..."
                onChange={(e) => debouncedSearch(e.target.value)}
                InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                    <Search fontSize="small" />
                    </InputAdornment>
                ),
                }}
                size="small"
                sx={{
                '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': {
                    borderColor: 'primary.main',
                    },
                },
                width: { xs: '100%', sm: 300 }
                }}
            />
            </Box>

      <Box style={{ height: 600, width: '100%' }}>
        <DataTable
          rows={rows}
          columns={columns}
          loading={loading}
          totalRows={totalRows}
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
        />
      </Box>
    </PageContainer>
  );
};

export default Enquiries;